// HM-303 demo: rendering icone Lucide usate dal design system v2.6.
// Routata in HM-307 a /dev/icons.

import {
  ArrowDown,
  ArrowUp,
  BedDouble,
  Bell,
  BookOpenCheck,
  CalendarClock,
  CalendarDays,
  Check,
  ChevronDown,
  ChevronRight,
  CircleCheck,
  Cpu,
  Download,
  Filter,
  HM_ICON_STROKE_WIDTH,
  LayoutDashboard,
  LogOut,
  type LucideIcon,
  Menu,
  Pencil,
  Plus,
  Printer,
  RefreshCw,
  Search,
  Settings2,
  Sparkles,
  Trash2,
  TrendingUp,
  TriangleAlert,
  Upload,
  UserCircle,
  Users,
  UtensilsCrossed,
  Wallet,
  Wind,
  X,
  Zap,
} from '@hotel-manager/ui/icons';

const sidebarIcons: Array<[string, LucideIcon]> = [
  ['LayoutDashboard', LayoutDashboard],
  ['CalendarDays', CalendarDays],
  ['BookOpenCheck', BookOpenCheck],
  ['Users', Users],
  ['Wallet', Wallet],
  ['TrendingUp', TrendingUp],
  ['UtensilsCrossed', UtensilsCrossed],
  ['Cpu', Cpu],
  ['Settings2', Settings2],
];

const stateIcons: Array<[string, LucideIcon, string]> = [
  ['CircleCheck (LIB)', CircleCheck, 'text-state-lib'],
  ['CalendarClock (RIS)', CalendarClock, 'text-state-ris'],
  ['BedDouble (OCC)', BedDouble, 'text-state-occ'],
  ['Sparkles (SPRC)', Sparkles, 'text-state-sprc'],
  ['TriangleAlert (GUAS)', TriangleAlert, 'text-state-guas'],
  ['Wind (PULIZ)', Wind, 'text-state-puliz'],
];

const actionIcons: Array<[string, LucideIcon]> = [
  ['Plus', Plus],
  ['Pencil', Pencil],
  ['Trash2', Trash2],
  ['Search', Search],
  ['Filter', Filter],
  ['Download', Download],
  ['Printer', Printer],
  ['RefreshCw', RefreshCw],
  ['ChevronDown', ChevronDown],
  ['ChevronRight', ChevronRight],
  ['X', X],
  ['Check', Check],
  ['Bell', Bell],
  ['UserCircle', UserCircle],
  ['LogOut', LogOut],
  ['Menu', Menu],
  ['Zap', Zap],
  ['Upload', Upload],
  ['ArrowUp', ArrowUp],
  ['ArrowDown', ArrowDown],
];

function Cell({
  name,
  Icon,
  className = 'text-text-primary',
}: {
  name: string;
  Icon: LucideIcon;
  className?: string;
}) {
  return (
    <div className="bg-bg-card rounded-lg p-4 shadow-hm-sm flex flex-col items-center gap-2 min-w-0">
      <Icon size={28} strokeWidth={HM_ICON_STROKE_WIDTH} className={className} />
      <span className="text-xs text-text-secondary truncate w-full text-center">{name}</span>
    </div>
  );
}

export function IconsDemo() {
  return (
    <div className="min-h-screen bg-bg-base p-8 text-text-primary">
      <h1 className="text-3xl font-bold mb-2">Icone Lucide</h1>
      <p className="text-text-secondary mb-8">
        SPEC v2.6: stroke-width default 1.75px, importate centralmente da
        <code className="bg-bg-muted px-1.5 py-0.5 rounded text-sm ml-1">
          @hotel-manager/ui/icons
        </code>
        .
      </p>

      <section className="mb-10">
        <h2 className="text-xl font-semibold mb-4">Sidebar</h2>
        <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-3">
          {sidebarIcons.map(([n, Icon]) => (
            <Cell key={n} name={n} Icon={Icon} className="text-accent-primary" />
          ))}
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-xl font-semibold mb-4">Stati camere</h2>
        <div className="grid grid-cols-3 md:grid-cols-6 gap-3">
          {stateIcons.map(([n, Icon, c]) => (
            <Cell key={n} name={n} Icon={Icon} className={c} />
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Azioni</h2>
        <div className="grid grid-cols-4 md:grid-cols-6 lg:grid-cols-10 gap-3">
          {actionIcons.map(([n, Icon]) => (
            <Cell key={n} name={n} Icon={Icon} />
          ))}
        </div>
      </section>
    </div>
  );
}
